import React from "react"
import dayjs from "utils/dates"

// antd
import {
  Typography,
  Drawer,
  Divider,
  Flex,
  Collapse,
  List,
  Space,
  Empty,
  Button,
} from "antd"
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons"

// store
import { useOrders } from "store/orders"

// i18n
import { useTranslation } from "react-i18next"

// components
import OrderStatusTag from "./OrderStatusTag"
import MenuDrawerOrder from "./MenuDrawerOrder"

const MenuDrawerOrders = ({ onClose, open }) => {
  const { t } = useTranslation()

  const [selectedOrder, setSelectedOrder] = React.useState(null)

  const { orders } = useOrders()

  if (!orders) return null

  // group orders by month and year
  const groupedOrders = orders.reduce((groups, order) => {
    const date = new Date(order.created_at.toDate())
    const monthYear = dayjs(date).format("MMMM YYYY")
    if (!groups[monthYear]) {
      groups[monthYear] = []
    }
    groups[monthYear].push(order)
    return groups
  }, {})

  return (
    <Drawer
      title={t("menu")}
      closeIcon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
      placement="right"
      onClose={onClose}
      open={open}
    >
      <MenuDrawerOrder
        onClose={() => setSelectedOrder(null)}
        open={!!selectedOrder}
        order={selectedOrder}
      />

      <Typography.Title level={4}>{t("my_orders")}</Typography.Title>

      <Typography.Paragraph>
        {t("past_orders_description")}
      </Typography.Paragraph>

      <Divider />

      {orders.length === 0 && <Empty description={t("no_orders_yet")} />}

      {orders.length > 0 && (
        <Collapse
          defaultActiveKey={Object.keys(groupedOrders)[0]}
          accordion
          items={Object.keys(groupedOrders).map((monthYear) => ({
            key: monthYear,
            label: monthYear,
            children: (
              <div>
                <List
                  dataSource={groupedOrders[monthYear]}
                  renderItem={(order) => (
                    <List.Item
                      key={order.id}
                      onClick={() => setSelectedOrder(order)}
                    >
                      <List.Item.Meta
                        title={
                          <div>
                            <Flex justify="space-between">
                              <Space size="small" direction="vertical">
                                <Typography.Text strong>
                                  {`${`Bestellung: ${order.id
                                    .toUpperCase()
                                    .slice(0, 4)}`}`}
                                </Typography.Text>
                              </Space>
                            </Flex>
                            <Typography.Text
                              type="secondary"
                              style={{
                                fontWeight: "lighter",
                                fontStyle: "italic",
                              }}
                            >
                              {dayjs(order.created_at.toDate()).format(
                                "DD.MM.YYYY HH:mm"
                              )}
                            </Typography.Text>
                          </div>
                        }
                        description={<OrderStatusTag order={order} />}
                      />

                      <Button type="ghost">
                        Details <ArrowRightOutlined />
                      </Button>
                    </List.Item>
                  )}
                />
              </div>
            ),
          }))}
        />
      )}
    </Drawer>
  )
}

export default MenuDrawerOrders
